import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons';
import { UiSwitchModule } from 'ngx-ui-switch';

import { TaskModalComponent } from './task-modal.component';

@NgModule({
  declarations: [TaskModalComponent],
  imports: [
    CommonModule,
    CKEditorModule,
    UiSwitchModule,
    TooltipModule,
    NgxBootstrapIconsModule,
  ],
})
export class TaskModalModule {}
